import LoginForm from '../components/Auth/LoginForm';

const LoginPage = () => {
  return (
    <div >
      <LoginForm />
    </div>
  );
};

export default LoginPage;
